export default {
  9: 5.5,
  13: 5.5,
  19: 7.5,
  DEFAULT: 7.5,
};
